import {Controller} from '@hotwired/stimulus';

/**
 * Nombre de lignes par page du pied de liste (`common/pagination.html.twig`) : la page se recharge avec le nombre
 * choisi (`limit`), à la première page, en gardant ses autres paramètres (filtres).
 */
export default class extends Controller {
  change() {
    const url = new URL(window.location.href);

    url.searchParams.set('limit', this.element.value);
    url.searchParams.delete('page');
    window.location.assign(url);
  }
}
